<template>
  <div class="dash-profile">
    <m-a class="dash-profile-user" :href="{name:'Profile'}">
      <img
        v-if="!$store.getters['User/getProfile'].image"
        src="../../../../../public/profile.webp"
        class="dash-profile-avatar"
        alt=""
      >
      <img
        v-else
        class="dash-profile-avatar"
        :src="$store.getters['User/getProfile'].image"
        alt="profile"
      >
      <span class="dash-profile-name">{{ displayName }}</span>
    </m-a>
    <button type="button" class="dash-profile-logout" aria-label="خروج" @click="logout()">
      <b-icon icon="power"/>
    </button>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "MenuUserWidget",
  methods: {
    findAttributeOnSiteInfo,
    logout() {
      this.$store.dispatch("Authentication/logout")
    }
  },
  computed: {
    ...mapGetters({
      user: "User/getProfile"
    }),
    displayName() {
      const name = (((this.user && this.user.name) || '') + ' ' + ((this.user && this.user.last_name) || '')).trim()
      return name || 'حساب کاربری'
    },
  },
}
</script>

<style scoped>
.dash-profile {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 252, 250, 0.96);
  border-radius: 16px;
  padding: 8px 10px;
  box-shadow: 0 8px 18px rgba(30, 30, 30, 0.12);
}

.dash-profile-user {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
  color: #1e1e1e !important;
  text-decoration: none !important;
}

.dash-profile-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.dash-profile-name {
  min-width: 0;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dash-profile-logout {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 10px;
  background: rgba(235, 61, 96, 0.1);
  color: #eb3d60;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
}

.dash-profile-logout:hover,
.dash-profile-logout:focus {
  background: #eb3d60;
  color: #fff;
  outline: none;
}
</style>
